import FooterWave from './FooterWave';

export default FooterWave;